import { Injectable, inject } from '@angular/core';
import { AudioRecordingService } from '@llm/service/audio_recording.service';
import { VoiceCommandService } from '@llm/service/voice_command.service';
import { ChatUIService } from '@llm/service/chat_ui.service';
import {llmStoreService} from '@llm/service/llm_store.service';
import{MessageService} from '@llm/service/message.service'
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

export type VoiceCommand =
  | 'OpenChatNitro'
  | 'FechouGrab'
  | 'FecharChat'
 // | 'SilentVoiceUser';

/**
 * @description Servicio encargado de ejecutar las acciones detectadas
 * por comando de voz
 */

@Injectable({ providedIn: 'root' })
export class VoiceCommandActionsService {
  store = inject(llmStoreService);
  _messageService = inject(MessageService);
  private _console = inject(Tools_aiConsoleService);
  constructor(
    private audioRecordingService: AudioRecordingService,
    private voiceCommandService: VoiceCommandService,
    private chatUIService: ChatUIService
  ) {}

  executeAction(
    command: VoiceCommand,
  ): void {
    const actions: Record<VoiceCommand, () => void> = {
      'OpenChatNitro': () => this.handleOpenNitro(),
      'FechouGrab': () => this.handleStopRecording(),
      'FecharChat': () => this.handleCloseChat(),
      //'SilentVoiceUser': () => this.handleCloseChat(),
    };

    actions[command]?.();
  }

  private handleOpenNitro(): void {
    if (!this.store.isShowChat()) {
      this.initNitroChatRecording();
      this.voiceCommandService.removeCommandFromBuffer('oi gloria');
      this._messageService.obterMensagemAleatoria().finally(()=>{
        this.audioRecordingService.resumeRecording();
      })
      this.audioRecordingService.startRecording();
    } else if (!this.store.isRecording()) {
      this.audioRecordingService.startRecording();
      this.voiceCommandService.removeCommandFromBuffer('oi gloria');
    }

  }

  private handleStopRecording(): void {
    if(!this.store.isRecording()){
      return;
    }
    this.audioRecordingService.stopRecording();
      this.voiceCommandService.removeCommandFromBuffer('fechou');
  }

  private handleCloseChat(): void {
    this.voiceCommandService.removeCommandFromBuffer('valeu');
    this.audioRecordingService.stopRecording();
    //this._messageService.obterMensagemDespedidaAleatoria()
    this.store.setShowChat(false); // Cierra el chat
  }

  private initNitroChatRecording(): void {
    this.store.setShowChat(true); //abre ventana de chat de nitro para apoyo visual al usuario
    if(this.store.isFirstRenderedChat()==0){}
    setTimeout(() => this.audioRecordingService.startRecording(), 100);
  }
}
